import { useApiAvailability } from "@babackapp/private-api-client/client/use-api-availability";
import { useFlags } from "launchdarkly-react-client-sdk";

import type { WidgetUnavailableReason } from "../components/widget-unavailable";
import { useIsMerchant } from "./use-is-merchant";

// Shared by the gate and by the Suspense fallback. The gate alone is not enough: it
// sits inside the Suspense boundary, so while the boot query is still pending the
// fallback is what's on screen — and a hanging API never resolves, so the gate would
// never get a chance to render.
export function useWidgetUnavailableReason(): WidgetUnavailableReason | null {
  const availability = useApiAvailability();
  const flags = useFlags();
  const isMerchant = useIsMerchant();

  if (availability === "unreachable") return "api-down";

  // The maintenance flag is a customer-facing announcement, so merchants opening the
  // widget from the back-office are not gated by it — they're warned elsewhere. A dead
  // API blocks everyone, since nothing in the flow can complete anyway.
  if (flags.isReturnWidgetMaintenanceEnabled === true && !isMerchant) return "maintenance";

  return null;
}
